;(function () {
  'use strict'

  angular
    .module('contrast.avatar')
    .constant('CAT_AVATARS', [
      'avatarDetectiveCat.png',
      'avatarEmojiCat.png',
      'avatarRoyalCat.png',
      'avatarSnowboarderCat.png',
      'avatarSpaceCat.png',
      'avatarCowboyCat.png',
      'avatarCattyBoh.png',
      'avatarNinjaCat.png',
      'avatarPolyCat.png',
      'avatarSkeletorCat.png'
    ])
    .constant('DEFAULT_AVATAR', 'images/onboarding/default.png')
    .constant('CONTRAST_AVATAR', 'images/logos/cs_icon.svg')
})()
